import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 overflow-hidden bg-gradient-to-br from-neutral-light via-white to-primary-light/20">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_40%_25%,rgba(255,87,34,0.05)_0%,rgba(255,255,255,0)_50%)]"></div>
      
      <div className="container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 max-w-2xl animate-fade-in">
            <h1 className="font-bold text-4xl md:text-5xl lg:text-6xl text-secondary leading-tight">
              Your New Website Is <span className="text-primary">Already Built</span>.
            </h1>
            
            <p className="text-lg md:text-xl text-secondary-light animate-slide-up delay-100">
              We help contractors and small businesses get professional websites that generate leads. 
              If we reached out, it's because we saw your current site and built you something better - already customized for your business.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 pt-4 animate-slide-up delay-200">
              <a href="#contact" className="btn-primary btn-lg">
                Book a Quick Call
              </a>
              <Link to="/contact" className="btn-secondary btn-lg">
                Request More Info
              </Link>
            </div>
          </div>
          
          <div className="relative animate-fade-in delay-300">
            <div className="absolute -inset-0.5 bg-gradient-to-br from-primary/40 to-accent/40 rounded-3xl blur-xl opacity-30 animate-pulse"></div>
            <div className="relative overflow-hidden rounded-3xl shadow-soft-lg">
              <img 
                src="https://images.unsplash.com/photo-1467232004584-a241de8bcf5d" 
                alt="Modern web design workspace" 
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-neutral-light to-transparent"></div>
    </section>
  );
};

export default Hero;
